import { ContractLanguageView } from "./ContractLanguageView";

const GENERAL_CONTRACT_LANGUAGE_ID = "c566c75b-d6b2-48e2-b203-78eea1c1e6d6";

export function ContractsLanguageGeneralDashboard() {
  return (
    <ContractLanguageView
      knowledgeItemId={GENERAL_CONTRACT_LANGUAGE_ID}
      title="General Contract Language"
    />
  );
}
